import { createFileRoute } from '@tanstack/react-router'
import { RegisterPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/register')({
  head: () => noIndexRouteHead('register', 'en'),
  component: RegisterPage,
})
